import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { CodeListNormalized } from './code.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/code');

export const getCodeList = actionCreator.async<{}, CodeListNormalized>('GET_CODE_LIST');
export const getCodeListWithDelay = actionCreator.async<void, CodeListNormalized>('GET_CODE_LIST_WITH_DELAY');
